export default function InputLabel({ forInput, value, className, children }) {
    return (
        <label
            htmlFor={forInput}
            className={className || `block text-gray-700 `}
        >
            {value ? value : children}
        </label>
    );
}
